module.exports = {
  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',

  GET_USER_DETAILS_ERROR: 'GET_USER_DETAILS_ERROR',
  GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',

  GET_DELIVERIES_LIST_SUCCESS: 'GET_DELIVERIES_LIST_SUCCESS',
  GET_DELIVERIES_LIST_ERROR: 'GET_DELIVERIES_LIST_ERROR',

  UPDATE_USER_DATA_SUCCESS: 'UPDATE_USER_DATA_SUCCESS',
  UPDATE_USER_DATA_ERROR: 'UPDATE_USER_DATA_ERROR',

  GET_REPORT_DATA_SUCCESS: 'GET_REPORT_DATA_SUCCESS',
  GET_REPORT_DATA_ERROR: 'GET_REPORT_DATA_ERROR',

  GET_STRIPE_CUSTOMER_SUCCESS: 'GET_STRIPE_CUSTOMER_SUCCESS',
  GET_STRIPE_CUSTOMER_ERROR: 'GET_STRIPE_CUSTOMER_ERROR',

  GET_STRIPE_CHECKOUT_SESSION_SUCCESS: 'GET_STRIPE_CHECKOUT_SESSION_SUCCESS',
  GET_STRIPE_CHECKOUT_SESSION_ERROR: 'GET_STRIPE_CHECKOUT_SESSION_ERROR',
  POST_STRIPE_CHECKOUT_SESSION_SUCCESS: 'POST_STRIPE_CHECKOUT_SESSION_SUCCESS',
  POST_STRIPE_CHECKOUT_SESSION_ERROR: 'POST_STRIPE_CHECKOUT_SESSION_ERROR',

  SUBSCRIBE_TO_RENEWAL_SUCCESS: 'SUBSCRIBE_TO_RENEWAL_SUCCESS',
  SUBSCRIBE_TO_RENEWAL_ERROR: 'SUBSCRIBE_TO_RENEWAL_ERROR',

  CANCEL_SUBSCRIPTION_SUCCESS: 'CANCEL_SUBSCRIPTION_SUCCESS',
  CANCEL_SUBSCRIPTION_ERROR: 'CANCEL_SUBSCRIPTION_ERROR',
};



// WEBPACK FOOTER //
// ./constants/CommonConstants.js